import React, {useContext, useEffect, useReducer, useRef, useState} from 'react';
import format from 'date-fns/format';
import CoinsSwapIcon from 'app/components/Icons/CoinsSwapIcon';
import BankIcon from 'app/components/Icons/BankIcon';
import ManatIcon from 'app/components/Icons/ManatIcon';
import SwitchIcon from 'app/components/Icons/SwitchIcon';
import GlobusIcon from 'app/components/Icons/GlobusIcon';
import CoinsStackedIconSelect from 'app/components/Icons/CoinsStackedIconSelect';
import WalletIconSelect from 'app/components/Icons/WalletIconSelect';
import SaleIcon from 'app/components/Icons/SaleIcon';
import { useMediaQuery } from '@mui/material';
import {onlyDigit, onlyNumber, onlyNumberAndLetters} from 'app/constants/regex';
import logger from 'app/utils/logger';
import { useTranslation } from 'react-i18next';
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {schemaFilter} from "app/components/Filter/schema";
import {useFilterChangeTransactions} from "app/utils/services/transactionsService";
import {useLayoutContext} from "app/storage/LayoutContext";
import useCurrencySymbol from "app/utils/customHooks/useCurrencySymbol";

interface Props {
  selectedAccount?: string;
  paymentType?: any;
  btnId?: number;
  setPaymentType?: any;
  voen?: any;
  setVoen?: any;
  client?: any;
  setClient?: any;
  selectedPeriod?: any;
  setSelectedPeriod?: any;
  resNextDate?: any;
  setNextResDate?: any;
  resEndDate?: any;
  setEndResDate?: any;
  fromAmount?: any;
  setFromAmount?: any;
  toAmount?: any;
  setToAmount?: any;
  filterCounter?: number;
  setFilterCounter?: any;
  showCount?: any;
  setShowCount?: any;
  mainCount?: any;
  setMainCount?: any;
  showFilter?: any;
  setShowFilter?: any;
  isClean?: boolean;
  setIsClean?: any;
  resDate?: any;
  setResDate?: any;
  endDate?: any;
  setEndDate?: any;
  setPage: any;
  handleCheckData: (id: number) => void;
  filterTransactionMutation: any;
}

const useFilter = (props: Props) => {
  const {
    selectedAccount,
    paymentType,
    btnId,
    setPaymentType,
    voen,
    setVoen,
    client,
    setClient,
    selectedPeriod,
    setSelectedPeriod,
    resNextDate,
    setNextResDate,
    resEndDate,
    setEndResDate,
    fromAmount,
    setFromAmount,
    toAmount,
    setToAmount,
    filterCounter,
    setFilterCounter,
    showCount,
    setShowCount,
    mainCount,
    setMainCount,
    showFilter,
    setShowFilter,
    isClean,
    setIsClean,
    resDate,
    setResDate,
    endDate,
    setEndDate,
    setPage,
    handleCheckData,
    filterTransactionMutation
  } = props;
  const { t } = useTranslation();
  const [focused, setFocused] = useState(false);
  const {layoutState, setLayoutContext} = useLayoutContext();

  const [accOptions,setAccOptions] = useState([]);


  const options = [
    { value: 'payment_acc2acc', label: t('homePage.acc2acc'), icon: <CoinsSwapIcon /> },
    { value: 'payment_interbank', label: t('homePage.inBank'), icon: <BankIcon /> },
    { value: 'payment_local_transfer', label: t('homePage.inCountry'), icon: <ManatIcon /> },
    { value: 'payment_foreign_transfer', label: t('homePage.internal'), icon: <GlobusIcon /> },
    {
      value: 'payment_conversion',
      label: t('homePage.conversion'),
      icon: <SwitchIcon sx={{ width: '20px', height: '20px' }} />,
    },
    { value: 'payment_edv', label: t('homePage.edv'), icon: <CoinsStackedIconSelect /> },
    { value: 'payment_budget', label: t('homePage.stateBudget'), icon: <WalletIconSelect /> },
    // { value: 'Kredit ödənişi', label: t('homePage.credit'), icon: <SaleIcon /> },
  ];


  useEffect(() => {
    const accountData = layoutState?.accounts?.map((item: any) => {
      return {
        value: item.iban,
        label: `${item.emp_title} (${item.iban}) - ${item.main_balance} ${useCurrencySymbol(item.currency)}`,
        balance: item.main_balance,
        blocked: item.blocked_balance,
        name: item.emp_title,
        have_tax_order: item.have_tax_order,
        currency: item.currency,
        status: item.state,
        iban: item.iban,
      };
    });
    setAccOptions(accountData);
  }, []);

  const period = [
    { value: '0', label: t('homePage.today') },
    { value: '1', label: t('homePage.currentMonth') },
    { value: '2', label: t('homePage.lastMonth') },
    { value: '12', label: t('homePage.year') },
    { value: '-1', label: t('homePage.range') },
  ];

  // const [startDate, setStartDate] = useState(null);
  // const [endDate, setEndDate] = useState(null);

  // const [filterCounter, setFilterCounter] = useState(0);
  // const [mainCount, setMainCount] = useState(0);
  // const [showCount, setShowCount] = useState(false);
  //
  // const [showFilter, setShowFilter] = useState(false);

  // const [isClean, setIsClean] = useState(false);
  // const [paymentType, setPaymentType] = useState<any>(null);
  // const [client, setClient] = useState('');
  // const [voen, setVoen] = useState('');
  // const [resDate, setResDate] = useState('');
  const resDateRef = useRef(null);
  // const [fromAmount, setFromAmount] = useState('');
  // const [toAmount, setToAmount] = useState('');
  //
  const [firstFocused, setFirstFocused] = useState(false);
  const [secondFocused, setSecondFocused] = useState(false);
  const [nextDate, setNextDate] = useState(null);
  // const [endDate, setEndDate] = useState(null);
  // const [resNextDate, setNextResDate] = useState('');
  // const [resEndDate, setEndResDate] = useState('');
  //
  // const [selectedPeriod, setSelectedPeriod] = useState<{ value: string; label: string }>();

  const smallScreen = useMediaQuery('(max-width: 1600px)');

  const onFocusNext = () => {
    setFirstFocused(true);
  };
  const onFocusEnd = () => {
    setSecondFocused(true);
  };

  const handlerBlur = () => {
    setFirstFocused(false);
    setSecondFocused(false);
  };

  const handlerNextDate = (startDate_: any) => {
    setResDate(startDate_);
    setNextResDate(format(startDate_, 'dd/MM/yyyy'));
    handlerBlur();
    if (resDate === null) {
      setFilterCounter(filterCounter + 1);
    }
  };
  const handlerEndDate = (endDate_: any) => {
    setEndDate(endDate_);
    setEndResDate(format(endDate_, 'dd/MM/yyyy'));
    handlerBlur();
    if (endDate === null) {
      setFilterCounter(filterCounter + 1);
    }
  };

  const onChangePeriod = (newValue: any) => {
    setSelectedPeriod(newValue);
    if (selectedPeriod === null) {
      setFilterCounter(filterCounter + 1);
    }
  };

  useEffect(() => {
    if (
      (paymentType !== null && Object.keys(paymentType).length > 0) ||
      client.length > 0 ||
      voen.length > 0 ||
      (selectedPeriod !== null && Object.keys(selectedPeriod).length > 0) ||
      (resDate !== null && resDate.length > 0) ||
      fromAmount.length > 0 ||
      toAmount.length > 0 || resNextDate.length > 0 || resEndDate.length > 0
    ) {
      setIsClean(true);
    } else {
      setIsClean(false);
    }
  }, [client, voen, resDate, paymentType, fromAmount, toAmount, selectedPeriod,resNextDate,resEndDate]);

  // const handlerDate = (dates: any, event: any) => {
  //   const [start, end] = dates;
  //
  //   setStartDate(null);
  //   setEndDate(null);
  //
  //   if (end != null) {
  //     setStartDate(start);
  //     setEndDate(end);
  //     setResDate(`${format(start, 'dd/MM/yyyy')}-${format(end, 'dd/MM/yyyy')}`);
  //     setFocused(false);
  //   } else {
  //     setStartDate(start);
  //     setResDate(format(start, 'dd/MM/yyyy'));
  //   }
  //
  //   if (resDate.length === 0) {
  //     setFilterCounter(filterCounter + 1);
  //   }
  // };
  const onFocus = () => {
    setFocused(true);
  };
  // const handlerBlur = () => {
  //   setFocused(false);
  // };

  const handleChangeAcc = (newValue: any) => {
    setPaymentType(newValue);
    logger.log("Paymet Type:", paymentType);
    if (paymentType === null) {
      setFilterCounter(filterCounter + 1);
    }
  };

  const handleChangePaymentType = (newValue: any) => {
    setPaymentType(newValue);
    logger.log("Paymet Type:", paymentType);
    if (paymentType === null) {
      setFilterCounter(filterCounter + 1);
    }
  };

  const handleChangeClient = (event: any) => {
    // if (onlyNumberAndLetters.test(event.target.value)) {
    // }

    setClient(event.target.value);


    if (client.length === 0) {
      setFilterCounter(filterCounter + 1);
    }

    if (event.target.value === '') {
      setFilterCounter(filterCounter - 1);
    }
  };

  const handleChangeVoen = (event: any) => {
    if (event.target.value === '' || onlyNumber.test(event.target.value)) {
      setVoen(event.target.value);
    }
    if (voen.length === 0) {
      setFilterCounter(filterCounter + 1);
    }

    if (event.target.value === '') {
      setFilterCounter(filterCounter - 1);
    }
  };

  const handlerChangeFromAmount = (event: any) => {
    if (event.target.value === '' || onlyDigit.test(event.target.value)) {
      setFromAmount(event.target.value);

      if (fromAmount.length === 0) {
        setFilterCounter(filterCounter + 1);
      }

      if (event.target.value === '') {
        setFilterCounter(filterCounter - 1);
      }
    }
  };

  const handlerChangeToAmount = (event: any) => {
    if (event.target.value === '' || onlyDigit.test(event.target.value)) {
      setToAmount(event.target.value);

      if (toAmount.length === 0) {
        setFilterCounter(filterCounter + 1);
      }

      if (event.target.value === '') {
        setFilterCounter(filterCounter - 1);
      }
    }
  };

  const handlerChangeDateInput = (event: any) => {
    setResDate(event.target.value);

    if (event.target.value === '') {
      setFilterCounter(filterCounter - 1);
      // setStartDate(null);
      setEndDate(null);
    }
  };

  const resetAllInput = () => {

    setPage(1);

    filterTransactionMutation({
      acc_no: '',
      trn_type: '',
      end_date: '',
      start_date: '',
      period_type:0,  //for periods
      start_amount: '',
      end_amount: '',
      cr_custname: '',
      cr_taxno: '',
      search: '',
      db_cr_filter: btnId === 1 ? '' : btnId === 2 ? 'cr' : btnId === 3 && 'db',
      state: [],
    });


    setPaymentType(null);
    setClient('');
    setVoen('');
    setSelectedPeriod(null);
    setNextResDate('');
    setEndResDate('');
    setResDate(null);
    setEndDate(null);
    setFromAmount('');
    setToAmount('');
    setIsClean(false);
    setFilterCounter(0);
    setShowCount(false);
  };

  const resetWithRequest = async () => {
    await resetAllInput();
    handleCheckData(btnId);
  }

  const handleSubmitFilter = () => {
    if (filterCounter > 0) {
      setShowCount(true);
    } else {
      setShowCount(false);
    }
    setPage(1);

    handleCheckData(btnId)

    setMainCount(filterCounter);
    setShowFilter(false);
  };

  const {
    handleSubmit,
    control,
    register,
    getValues,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schemaFilter) , context: {voen}})



  return {
    t,
    options,
    filterCounter,
    mainCount,
    setFilterCounter,
    showCount,
    setShowCount,
    showFilter,
    setShowFilter,
    paymentType,
    smallScreen,
    handleChangePaymentType,
    client,
    handleChangeClient,
    voen,
    handleChangeVoen,
    fromAmount,
    handlerChangeFromAmount,
    toAmount,
    handlerChangeToAmount,
    isClean,
    // resetAllInput,
    focused,
    // startDate,
    // endDate,
    resDate,
    handlerChangeDateInput,
    onFocus,
    // handlerBlur,
    // handlerDate,
    handleSubmitFilter,
    resDateRef,
    period,
    firstFocused,
    secondFocused,
    onFocusNext,
    onFocusEnd,
    handlerBlur,
    nextDate,
    endDate,
    resNextDate,
    resEndDate,
    handlerNextDate,
    handlerEndDate,
    onChangePeriod,
    selectedPeriod,
    control,
    register,
    errors,
    handleSubmit,
    resetAllInput,
    resetWithRequest,
    accOptions
  };
};

export default useFilter;
